module.exports = __webpack_public_path__ + "77726925ebf7dba261ab8983806aa7ce.woff2";